import React from 'react';

import { AppContext } from '../contexts';
import { AppType, getAppTypeLabel } from '../enums';

export const useDocumentTitle = (title?: string): void => {
  const {
    appState: { currentApp }
  } = React.useContext(AppContext);

  React.useEffect(() => {
    if (title != null && title !== '') {
      document.title = `SpecDeck - ${title}`;
    } else {
      const currentAppName = currentApp != AppType.Quicklister ? getAppTypeLabel(currentApp) : null;
      document.title = 'SpecDeck' + (currentAppName != null ? ` - ${currentAppName}` : '');
    }
  }, []);
};
